export default "__VITE_ASSET__ee98fe60__"